export default __webpack_public_path__ + "static/media/noise_normal_light.3499eb76.svg";